import React, { Component } from 'react';
import { translate } from 'react-i18next';
import TextField from '@mui/material/TextField';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import lastOperationsIcon from './../img/last-operations-icon.png';
import Dropdown from '../../../copms/Dropdown/Dropdown';
import { request } from '../../../config';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import { getFormatedDate } from '../../../helpers/fotmatDate';
import { Autocomplete, Box } from '@mui/material';

class History extends Component {
    state = {
        status: 1,
        excelFileOutline: false,
        dateTo: new Date(),
        dateFrom: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
        currentPage: 1,
        lastPage: 0,
        search: '',
        respTransactions: [],
        accountList: [],
        iban: "",
        isLoading: false
    }

    setValues = (value, name) => {
        let newFormData = {
            ...this.state.formData,
            [name]: value
        };
        this.setState({ formData: newFormData })
    };

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    selectPage(e, page) {
        e.preventDefault();
        this.setState({ currentPage: page }, () => this.getList())
    }

    getAccounts = () => {
        let getConsentsRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("account/getAccountsInfoForConsentAcc", getConsentsRequestBody))
            .then(res => res.text())
            .then((getConsentsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getConsentsResponse = JSON.parse(getConsentsResponseJSON);
                if (getConsentsResponse.status.statusCode !== 1) {
                    if (getConsentsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getConsentsResponse.status.statusCode));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ accountList: getConsentsResponse?.accounts ? (getConsentsResponse?.accounts?.length != 0 ? getConsentsResponse?.accounts : []) : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getConsentsRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            dateFrom: this.state.dateFrom.toISOString().slice(0, 19),
            dateTo: this.state.dateTo.toISOString().slice(0, 19),
            iban: this.state.iban,
            page: this.state.currentPage
        }
        fetch(request("account/getConsentAccountTransactions", getConsentsRequestBody))
            .then(res => res.text())
            .then((getConsentsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getConsentsResponse = JSON.parse(getConsentsResponseJSON);
                if (getConsentsResponse.status.statusCode !== 1) {
                    if (getConsentsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getConsentsResponse.status.statusCode));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ lastPage: getConsentsResponse?.meta?.totalPages, respTransactions: getConsentsResponse?.respTransactions ? (getConsentsResponse?.respTransactions?.length != 0 ? getConsentsResponse?.respTransactions : []) : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    dropdownItemHandler = (index, item) => {
        switch (index) {
            case 0:
                this.props.history.push(`/dashboard/open-banking/list/history/item/${item?.iban}`, { item });
                break;
            case 1:
                this.downloadFile(item?.consentContent);
                break;
            case 2:
                this.setState({ open: true });
                break;
            default:
                return;
        }
    }

    getFormatedDate(date) {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 10) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.year + '-' + formatedDate.month + '-' + formatedDate.day;
        }
        return null;
    }

    componentDidMount() {
        this.getAccounts();
    }

    render() {
        let { isLoading, accountList, respTransactions, iban } = this.state;
        let { t } = this.props;
        return (
            <>
                <div className="dashboard-salary-order-container" style={{ height: '100%' }}>
                    <div className="dashboard-account-container-component align-items-end">
                        <StartDatePicker width={160} label={t("From date")} placeholder={t("DD/MM/YYYY")} name='dateFrom' value={this.state.dateFrom} updateDate={this.updateDate} />
                        <EndDatePicker width={160} label={t("To date")} placeholder={t("DD/MM/YYYY")} name='dateTo' value={this.state.dateTo} updateDate={this.updateDate} />
                        <Autocomplete
                            className='open-banking'
                            disablePortal
                            options={accountList}
                            getOptionLabel={option => `${option.bankName} ${option.iban} / ${option.balance} ${option.currency}`}
                            onChange={(event, value) => this.setState({ iban: value?.iban })}
                            sx={{ width: 510 }}
                            renderInput={(params) => <TextField {...params} placeholder={t('Choose')} label={t('account number')} />}
                        />
                    </div>
                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main ml-auto" disabled={!iban} onClick={() => { this.setState({ currentPage: 1 }, () => this.getList()) }}>{t("Search")}</button>
                    {isLoading || respTransactions.length === 0 ?
                        <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                            <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                            <p className="dashboard-last-operations-section-content-status">{t('463')}</p>
                        </div>
                        : <>
                            <table className='dashboard-account-body-table'>
                                <thead>
                                    <tr>
                                        <th>{t('Account')}</th>
                                        <th>{t('date')}</th>
                                        <th>{t('Amount')}</th>
                                        <th>{t('Appointment')}</th>
                                        <th>{t('detailed')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {respTransactions.map(item => (
                                        <tr>
                                            <td>{item.iban}</td>
                                            <td>{item.bookingDateTime}</td>
                                            <td>{item.amount} {item.currency}</td>
                                            <td><span style={{ background: `${item.color}1A`, color: item.color, borderRadius: '6px', padding: '6px 22px' }}>{item.creditDebitIndicator}</span></td>
                                            <td>
                                                <Dropdown
                                                    dropdownItems={[
                                                        {
                                                            title: this.props.t("detailed"),
                                                        }
                                                    ]}
                                                    dropdownItemHandler={(i) =>
                                                        this.dropdownItemHandler(i, item)
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                <ul className="dashboard-pagination">
                                    {this.state.currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage - 1)}>{t('previous-page')}</a></li>}
                                    {
                                        Array.from({ length: this.state.lastPage }).map((item, index) => {
                                            if (this.state.lastPage > 3) {
                                                if (this.state.currentPage - 1 == index + 1) {
                                                    return (
                                                        <>
                                                            {this.state.currentPage > 2 && <li><a href="#" onClick={(e) => this.selectPage(e, 1)}>1</a></li>}

                                                            {this.state.currentPage > 3 && <li><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                            <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                        </>
                                                    )
                                                }
                                                if (this.state.currentPage == index + 1) {
                                                    return (
                                                        <>
                                                            <li className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                        </>
                                                    )
                                                }
                                                if (this.state.currentPage + 1 == index + 1) {
                                                    return (
                                                        <>
                                                            <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                            {this.state.currentPage < this.state.lastPage - 2 && <li ><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}

                                                            {this.state.currentPage + 1 < this.state.lastPage && <li ><a href="#" onClick={(e) => this.selectPage(e, this.state.lastPage)}>{this.state.lastPage}</a></li>}
                                                        </>
                                                    )
                                                }
                                            } else {
                                                return (
                                                    <li className={index + 1 == this.state.currentPage ? "active" : ""}><a href="#" style={this.state.lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                )
                                            }
                                        })
                                    }
                                    {this.state.currentPage != this.state.lastPage && this.state.lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage + 1)}>{t('next-page')}</a></li>}
                                </ul>
                            </div>
                        </>
                    }
                </div>
            </>
        )
    }
}

export default translate("translation")(History);